var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zw-completion" }, [
    _c("div", { staticClass: "merchant info" }, [
      _c("div", { staticClass: "merchant-logo" }, [
        _c("img", {
          attrs: { src: _vm.activeMerchant.logo, alt: _vm.activeMerchant.name }
        })
      ]),
      _vm._v(" "),
      _c("h1", {
        staticClass: "merchant-name",
        domProps: { innerHTML: _vm._s(_vm.activeMerchant.name) }
      }),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "message" }, [
      _c("h1", { staticClass: "ui header" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("pages.setup.usersuccess.header")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(_vm.$t("pages.setup.usersuccess.message"))
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ui blue button",
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "dashboard" })
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("pages.setup.usersuccess.button")) + "\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkbox" }, [
      _c("i", { staticClass: "checkmark icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea52432", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea52432","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/setup/UserSuccess.vue
// module id = pOBP
// module chunks = 1